import { ArrowLeft, Power } from 'lucide-react';

interface DeactivateConfirmFooterProps {
  submitting: boolean;
  onBack: () => void;
  onSubmit: () => void;
}

export default function DeactivateConfirmFooter({
  submitting,
  onBack,
  onSubmit,
}: DeactivateConfirmFooterProps) {
  return (
    <div className="px-[22px] py-3.5 border-t border-stone-200 dark:border-stone-800 bg-stone-50 dark:bg-[#1e2520] flex items-center gap-2.5 mt-2">
      <button
        type="button"
        onClick={onBack}
        disabled={submitting}
        className="inline-flex items-center gap-1 h-8 px-3 rounded-lg text-[12px] font-semibold text-stone-600 dark:text-stone-400 hover:bg-stone-100 dark:hover:bg-[#242d28] disabled:opacity-50"
      >
        <ArrowLeft size={12} />
        Back
      </button>
      <div className="flex-1 text-[11px] text-stone-500 dark:text-stone-400">Step 2 of 2</div>
      <button
        type="button"
        onClick={onSubmit}
        disabled={submitting}
        className="inline-flex items-center gap-1.5 h-8 px-3.5 rounded-lg text-[13px] font-semibold text-white bg-clay-700 hover:bg-clay-800 disabled:opacity-50"
      >
        <Power size={13} />
        {submitting ? 'Deactivating…' : 'Deactivate user'}
      </button>
    </div>
  );
}
